<template>
  <Component :is="layout" />
</template>

<script>
import { defineAsyncComponent } from "vue";
// Constants
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Layout",
  computed: {
    layout() {
      return defineAsyncComponent(() => import("./LayoutDefault/LayoutDefault.vue"));
    },
  },
};
</script>
